import React, { Component } from "react"
import { connect } from 'react-redux'
import {
    updateGR_ItemAction,
    updateGR_ItemAccountAssignmentAction,
    getDataReleaseOrderAction
} from '../../redux/actions/GRAction'

import {
    getPODetailOriginalAction,
} from '../../redux/actions/MainAction'
import {
    EVENT_GET_PO_RELEASE_ORDER
} from '../../configs/EventTypes'
import { msg } from "../Notifications/MsgBox"

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { Input, DatePicker } from "../core"

import moment from 'moment'
import utilityHelper from "../../helpers/helperUtil"

const numeral = require('numeral')

class ReleaseOrderModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            poNo: '',
            itemNo: '',
            reldoc_item: [],
            reldoc_ref: {},
            page: 0,
            rowsPerPage: 10,
            type: '',
            target_qty: 0,
            unit: '',
        }

        window.emitter.addListener(EVENT_GET_PO_RELEASE_ORDER, this.setCurrentReleaseOrderModal.bind(this))
    }

    setCurrentReleaseOrderModal(object) {
        console.log('setCurrentReleaseOrderModal')
        console.log(object)
        this.setState({
            poNo: object.po_no,
            itemNo: object.itemNo,
            type: object.type,
            page: 0,
            rowsPerPage: 10,
            target_qty: object.target_qty,
            unit: object.unit
        })

        this.props.getDataReleaseOrder(object.po_no, object.itemNo).then(response => {

            const result_reldoc_ref = response.data
            const isSuccess = result_reldoc_ref.isSuccess === true

            if (isSuccess) {
                console.log(result_reldoc_ref)

                this.setState({
                    reldoc_ref: result_reldoc_ref,
                    reldoc_item: result_reldoc_ref.reldoc_ref_item,
                    type: object.type
                })
            }
            else{

                this.setState({...this.state,
                        poNo: '',
                        itemNo: '',
                        reldoc_item: [],
                        reldoc_ref: {},
                        page: 0,
                        rowsPerPage: 10,
                        type: '',
                        target_qty: 0,
                        unit: '',})
            }

        }).catch(error => {
            if (error.message) {
                msg.error(error.message)
            }
        })

    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    render() {

        const { poNo,
            itemNo,
            reldoc_item,
            page,
            rowsPerPage,
            reldoc_ref,
            type,
            target_qty,
            unit
        } = this.state

        return (
            <div className="modal fade sp-modal rrs-modal" id="ReleaseOrderModal" tabIndex={-1} role="dialog" aria-labelledby="ReleaseOrderModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="ReleaseOrderModalLabel">Release Order Docu. for Contract {poNo}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body">

                            <div className="rrs-detail-data sp-table-container">

                                <div className="rrs-detail header-item-acc ">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <h5 className="text-header-item-acc">Item {itemNo}</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="row no-gutters sp-table-content">

                                    <div className="col-12">

                                        <Table className="sp-table table rrs-table">
                                            <TableHead>
                                                <TableRow className="sp-table-header">
                                                    <TableCell className="th-table text-center">PO</TableCell>
                                                    <TableCell className="th-table text-center">Item</TableCell>
                                                    <TableCell className="th-table text-center">Order Date</TableCell>
                                                    <TableCell className="th-table text-center">Order Qty</TableCell>
                                                    <TableCell className="th-table text-center">Unit</TableCell>
                                                    <TableCell className="th-table text-center">PO Value</TableCell>
                                                    <TableCell className="th-table text-center">Currency</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                { reldoc_item && reldoc_item.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        .map((datas, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell className="th-table text-center">{datas.contract_po_no}</TableCell>
                                                                <TableCell className="th-table text-center">{datas.item_no}</TableCell>
                                                                <TableCell className="th-table text-center">{datas.order_date ? moment(datas.order_date).format('DD/MM/YYYY') : ""}</TableCell>
                                                                <TableCell className="th-table text-right">{datas.order_qty}</TableCell>
                                                                <TableCell className="th-table text-center">{unit}</TableCell>
                                                                <TableCell className="th-table text-right">{datas.po_value ? (numeral(datas.po_value).format('0,0.00')) : ""}</TableCell>
                                                                <TableCell className="th-table text-center">{datas.currency}</TableCell>
                                                            </TableRow>
                                                        ))}

                                                { reldoc_item.length == 0 && (
                                                    <TableRow >
                                                        <TableCell colSpan="7" className="th-table text-center">No release documentation records found.</TableCell>
                                                    </TableRow>
                                                )}

                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            component="div"
                                            count={reldoc_item.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            backIconButtonProps={{
                                                'aria-label': 'previous page',
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'next page',
                                            }}
                                            onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                                            onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                                        />

                                    </div>
                                    

                                </div>
                            </div>

                            {(reldoc_ref.isSuccess && type == "item") && (
                                <div className="col-8">
                                    <table className="sp-table table rrs-table-2">
                                        <thead>
                                            <tr>
                                                <th className="th-table"><div className="th-text">Qty. released to date</div></th>
                                                <th className="th-table"><div className="th-text text-right">{reldoc_ref.sum_order_qty}</div></th>
                                                <th className="th-table"><div className="th-text">{unit}</div></th>
                                                <th className="th-table"><div className="th-text text-right">{reldoc_ref.sum_po_value}</div></th>
                                                <th className="th-table"><div className="th-text">{reldoc_ref.currency}</div></th>
                                            </tr>
                                            <tr>
                                                <th className="th-table"><div className="th-text">Target Qty</div></th>
                                                <th className="th-table"><div className="th-text text-right">{numeral(target_qty).format('0,0.000')}</div></th>
                                                <th colSpan="3" className="th-table"><div className="th-text">{unit}</div></th>
                                                {/* {reldoc_ref.po_target_qty} {reldoc_ref.unit} */}
                                            </tr>
                                            <tr>
                                                <th className="th-table"><div className="th-text">Open Target Qty</div></th>
                                                <th className="th-table"><div className="th-text text-right">{(utilityHelper.parseFloat(target_qty) - utilityHelper.parseFloat(reldoc_ref.sum_order_qty)) < 0 ? "0.000" : numeral(utilityHelper.parseFloat(target_qty) - utilityHelper.parseFloat(reldoc_ref.sum_order_qty)).format('0,0.000') }</div></th>
                                                <th colSpan="3" className="th-table"><div className="th-text">{unit}</div></th>
                                                {/* {reldoc_ref.unit} */}
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            )}

                            {(reldoc_ref.isSuccess && type == "service") && (
                                <div className="col-8">
                                    <table className="sp-table table rrs-table-2">
                                        <thead>
                                            <tr>
                                                <th className="th-table"><div className="th-text">Value released to date</div></th>
                                                <th className="th-table"><div className="th-text text-right">{reldoc_ref.sum_po_value}</div></th>
                                                <th className="th-table"><div className="th-text">{reldoc_ref.currency}</div></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            )}
                            
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        t_GR_ITEM: MainRedux.t_GR_ITEM,
        po_original: MainRedux.po_original,
        t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT
    }
}

const mapDispatchToProps = dispatch => {
    return {
        //saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
        updateGR_Item: (data, index = "", fieldName = "") => dispatch(updateGR_ItemAction(data, index, fieldName)),
        updateGR_ItemAccountAssignment: (data, index, fieldName) => dispatch(updateGR_ItemAccountAssignmentAction(data, index, fieldName)),
        getPODetailOriginal: (poNo, unitCode, userId) => dispatch(getPODetailOriginalAction(poNo, unitCode, userId)),
        getDataReleaseOrder: (poNo, itemNo) => dispatch(getDataReleaseOrderAction(poNo, itemNo)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReleaseOrderModal)